import { useMemo } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import { getContactUaeText } from "../../../locales/contact-uae";

export default function SecondSection() {
  const { t, locale } = useI18n();
  const contactUaeText = getContactUaeText(locale);

  const listItems = useMemo(() => {
    const raw = contactUaeText?.third_section?.list || [];
    return raw.map((item) => {
      // safer split (لو فيه ":" أكتر من مرة)
      const parts = String(item).split(":");
      const label = (parts[0] || "").trim();
      const value = parts.slice(1).join(":").trim(); // باقي النص كله
      return { label, value };
    });
  }, [contactUaeText]);

  return (
    <Box
      className="horizontal-safe-padding vertical-safe-padding"
      sx={{ backgroundColor: "#FFFFFF" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", lg: "row" },
          justifyContent: "space-between",
          alignItems: { lg: "center" },
          gap: 5,
        }}
      >
        {/* Text Side */}
        <Box>
          <Box sx={{ maxWidth: { sm: locale === "en" ? "650px" : "500px" } }}>
            <Box sx={{ position: "relative", display: "inline-block" }}>
              <Box
                component="h3"
                sx={{
                  color: "#2D317F",
                  fontSize: { xs: "20px", sm: "32px" },
                  fontWeight: "bold",
                  m: 0,
                }}
              >
                {contactUaeText.third_section.title}
              </Box>

              {/* Decorative line (fixed height => no CLS) */}
              <Box
                component="img"
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
                src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/line-main.webp"
                style={{
                  position: "absolute",
                  left: 0,
                  top: "100%",
                  marginTop: "3px",
                  width: "100%",
                  height: "6px",
                  objectFit: "cover",
                  transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
                  pointerEvents: "none",
                  display: "block",
                }}
              />
            </Box>
          </Box>

          <Typography
            sx={{
              fontWeight: 300,
              fontSize: "16px",
              lineHeight: "24px",
              width: { sm: "584px" },
              color: "#404456",
              mt: 2, 
            }}
          >
            {contactUaeText.third_section.description}
          </Typography>

          <Box
            component="ul"
            sx={{
              listStyleType: "disc",
              mt: 2,
              px: 2,
              width: { sm: locale === "en" ? "584px" : "561px" },
              m: 0,
              pl: locale === "en" ? 3 : 2,
              pr: locale === "ar" ? 3 : 2,
            }}
          >
            {listItems.map((it, index) => (
              <Typography
                key={index}
                component="li"
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "36px",
                  color: "#040921",
                }}
              >
                {it.label ? (
                  <span style={{ fontWeight: 600 }}>{it.label}:</span>
                ) : null}{" "}
                {it.value || ""}
              </Typography>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            width: { xs: "100%", md: 400, lg: 540 },
            aspectRatio: { xs: "16 / 9", md: "4 / 3", lg: "6 / 5" },
            position: "relative",
            borderRadius: "16px",
            overflow: "hidden",
            bgcolor: "transparent",
          }}
        >
          <Image
            src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/uae-section-3.webp"
            alt="uae section"
            fill
            sizes="(max-width: 900px) 100vw, 540px"
            style={{ objectFit: "cover" }}
            loading="lazy"
          />
        </Box>
      </Box>
    </Box>
  );
}
